import { BadgeCheck, ThumbsUp } from "lucide-react";
import type { Review } from "@/types";
import { StarsRating } from "@/components/atoms";
import { formatDate } from "@/lib/format";

export function ReviewCard({ review }: { review: Review }) {
  return (
    <article className="flex flex-col gap-2 border-b border-night-blue/10 py-5 last:border-0">
      <div className="flex items-center justify-between">
        <StarsRating value={review.rating} size={15} />
        <time className="text-xs text-night-blue/70">
          {formatDate(review.createdAt)}
        </time>
      </div>
      {review.title && (
        <h4 className="font-bold text-night-blue">{review.title}</h4>
      )}
      <p className="text-sm text-night-blue/70">{review.body}</p>
      <div className="flex items-center gap-3 text-xs text-night-blue/70">
        <span className="font-medium text-night-blue/70">
          {review.displayName}
        </span>
        {review.verified && (
          <span className="inline-flex items-center gap-1 text-leaf-green-ink">
            <BadgeCheck size={13} /> Verified
          </span>
        )}
        {review.helpfulCount > 0 && (
          <span className="inline-flex items-center gap-1">
            <ThumbsUp size={12} /> {review.helpfulCount}
          </span>
        )}
      </div>
    </article>
  );
}
